import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AngularFirestore } from '@angular/fire/firestore';
import firebase from 'firebase';
import { map } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { StorageService } from '../storage/storage.service';

export type Filters = 'accepted' | 'in-progress' | 'rejected';
export type ChallengesTypes = 'challenge' | 'geochallenge';
export type ExhibitsTypes = 'invoice' | 'exhibition';
export type Status = 'idle' | 'pending' | 'resolved' | 'rejected';
export type ItemData = { [field: string]: any } & { status: Filters; uid: firebase.User['uid'] };
export type ListData = { id: string, data: ItemData }[];

@Injectable({
  providedIn: 'root'
})
export class ExhibitionsService {

  type: ExhibitsTypes = 'exhibition'

  constructor(private firestore: AngularFirestore,
    private storageServices: StorageService,
    private http: HttpClient) { }

  newId() {
    return firebase.firestore().collection('temp').doc().id;
  }

  saveExhibition(data, uid) {
    var timestamp = new Date().getTime();
    const ID = timestamp.toString()
    const docRef = this.firestore.collection(`/ChallengeUsers/${uid}/Exhibitions/${uid}/Answers/`).doc(ID);
    docRef.set(data);
    return ID
  }

  async getExhibitions() {
    const claims = await this.storageServices.get("gnx-claims")
    const data = this.firestore
      .collection(`/ChallengeUsers/${claims.uid}/Exhibitions/${claims.uid}/Answers/`, ref => ref.where('uid', '==', claims.uid))
      .snapshotChanges()
      .pipe(map(
        acitons => acitons.map(a => {
          const data: any = a.payload.doc.data();
          const idRef = a.payload.doc.id;

          return { idRef, ...data };
        })
      ))
    return data;
  };

  async getDetail(id) {
    const claims = await this.storageServices.get("gnx-claims");
    return await this.firestore
      .collection(`/ChallengeUsers/${claims.uid}/Exhibitions/${claims.uid}/Answers/`)
      .ref
      .doc(id)
      .get()
      .then(data => {
        if (data.exists) {
          return data.data();
        }
      })
  }

  getStoreName(search, filter?){
    const requestOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      })
    };

    return new Promise((resolve, reject) =>
      this.http.get(`${environment.gluky.algoliaSearchUrl}/exh_stores?search=${search}`, requestOptions)
        .subscribe(data => {
          console.log("resultado", data);
          resolve(data);
        }, error => {
          console.log("cdc error", error);
          reject(error);
        })
    );
  }
}
